export function PageWrapper({ children }: { children: React.ReactNode }) {
    return (
        <div className="mx-auto mb-10 flex size-full min-h-[calc(100vh-100px)] flex-col items-start gap-5 overflow-y-scroll rounded-xl px-6 pt-8 transition-all duration-300 ease-in-out md:min-h-[calc(100vh-157px)] md:px-10">
            {children}
        </div>
    )
}
